export default {
  createANewRepair: "Crear un nuevo registro de reparación",
  equipmentTag: "Identificador del Equipo",
  createdBy: "Creado por",
  log: "Registro",
  submit: "Crear"
};
